import '../vendor/lazysizes'
import '../vendor/validation'
import '../vendor/validation/messages_ja'
import {default as Swiper} from '../vendor/swiper/swiper-bundle.min.js'
import inView from '../vendor/in-view'
import {Equal} from './equal-height'

// validate additional
jQuery.validator.addMethod('eisuji',
    function (value, element) {
        return this.optional(element) || value.match(/^[a-z0-9]*$/gm);
    },
    'サポートのみ a-z & 0-9.'
);

// Set cookie
function setCookie(cName, cValue, expDays) {
    const date = new Date();
    date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
    const expires   = "expires=" + date.toUTCString();
    document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
}

function documentOnload() {
    // trigger load complete
    document.body.classList.add('page-loaded');

    // form validate
    jQuery('.contact-form').each(function () {
        const form     = jQuery(this)
        const rules    = {}
        const messages = {}

        form.find(':input[data-rule]').each((index, el) => {
            const name = jQuery(el).attr('name')
            const rule = jQuery(el).attr('data-rule')

            rules[name]       = {}
            rules[name][rule] = true
        })

        form.validate({
            rules   : rules,
            messages: messages
        })
    })

    // Fixed image close
    jQuery('.fixed-image .close').on('click', function (e) {
        e.preventDefault();

        const button = jQuery(this),
              wrap   = button.closest('.fixed-image');

        setCookie('close-fixed-image', 1, 1)

        wrap.remove();
    });

    // Navbar
    jQuery('.view-sp .humberger').on('click', function (e) {
        e.preventDefault();

        const button = jQuery(this),
              wrap   = button.closest('.view-sp');

        button.toggleClass('open');
        jQuery('body').toggleClass('lock-scroll');

        wrap.children('.navbar-content').fadeToggle();
    });

    jQuery('.view-sp .arrow').on('click', function (e) {
        e.preventDefault();

        const button = jQuery(this),
              menu   = button.closest('li');

        button.toggleClass('open');

        menu.children('.dropdown').fadeToggle();
    });

    // Animation
    if (jQuery('.show-animate:not(.animate__animated)').length > 0) {
        inView('.show-animate:not(.animate__animated)').on('enter', el => {
            const animate  = el.getAttribute('data-animate'),
                  duration = el.getAttribute('data-duration') || '1.5s',
                  delay    = el.getAttribute('data-delay') || 10;
            if (duration) {
                el.style.setProperty('--animate-duration', duration);
            }
            setTimeout(function () {
                el.classList.add('' + animate);
                el.classList.add('animate__animated');
            }, delay);
        });
    }

    // Slider
    jQuery('.swiper-carousel:not(.swiper-initialized)').each(function () {
        const slider     = jQuery(this);
        const attr       = slider.attr('data-slider');
        const data       = attr ? JSON.parse(attr.replace(/'/g, '"').replace(';', '')) : {};
        const resizeGrid = function (swiper) {

        };

        const events = {
            beforeInit  : function (swiper) {
                resizeGrid(swiper);
            },
            beforeResize: function (swiper) {
                resizeGrid(swiper);
            },
        };

        const options = {
            ...{
                on           : events,
                direction    : 'horizontal', // 'horizontal' | 'vertical'
                loop         : false,
                slidesPerView: 'auto',
                spaceBetween : 0,
            },
            ...data
        }

        if (data.on) {
            for (const i in data.on) {
                options.on[i] = new Function(data.on[i]);
            }
        }

        if (!options.scrollbar && slider.find('.swiper-scrollbar').length > 0) {
            options.scrollbar = {
                el: '.swiper-scrollbar',
            };
        }

        if (!options.pagination && slider.find('.swiper-pagination').length > 0) {
            options.pagination = {
                el        : '.swiper-pagination',
                totalClass: '.swiper-pagination-total',
                clickable : true,
                type      : 'bullets', // 'bullets' | 'fraction' | 'progressbar' | 'custom'
            };
        }

        if (!options.navigation
            && slider.find('.swiper-button-next').length > 0
            && slider.find('.swiper-button-prev').length > 0) {
            options.navigation = {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            };
        }

        const swiper = new Swiper(this, options);

        swiper.on('slideChange', function () {
            // https://swiperjs.com/swiper-api#events
        });
    });

    // Equal height
    Equal('.equal-heights', '.equal-elem', 768)

    // Load google fonts
    if (typeof WebFontConfig !== "undefined") {
        import('./webfont').then(WebFont => WebFont.load(WebFontConfig));
    }
}

window.addEventListener('resize', function () {
    // Equal height
    Equal('.equal-heights', '.equal-elem', 768)
});

// After page load complete
if (window.addEventListener) {
    window.addEventListener('load', documentOnload);
} else if (window.attachEvent) {
    window.attachEvent('onload', documentOnload);
} else {
    window.onload = documentOnload;
}